import React from 'react'
import PropTypes from 'prop-types'
import { NumberCreator } from '@leverege/api-attributes'
import Util from './Util'

import { NumericInput } from '~/views'

export default class NumberEditor extends React.Component {

  static TYPE = NumberCreator.typeName();

  static propTypes = {
    attribute : PropTypes.object,
    name : PropTypes.string,
    value : PropTypes.number,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.onChange = Util.onChange.bind( this )
  }

  shouldComponentUpdate( nextProps, nextState ) {
    return false
  }
  
  render() {
    const { attribute : attr, value, focus, changeOnReturn, alwaysFireOnReturn, changeOnBlur = false } = this.props
    if ( attr == null ) {
      return <div />
    }
 
    return (
      <div>
        <NumericInput
          hint="Set value..." 
          value={value}
          float
          focus={focus}
          min={attr.min}
          max={attr.max}
          changeOnBlur={changeOnBlur}
          changeOnReturn={changeOnReturn}
          alwaysFireOnReturn={alwaysFireOnReturn}
          onChange={this.onChange} />
      </div>
    ) 
  }
}
